import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { apiHelper } from 'helpers';
import { simulationService } from 'services';
import { appSelectors } from 'redux/ducks/app';
import AssignmentContent from 'components/common/assignment-content/AssignmentContent';
import { ELSPageLoader } from 'components/common/els';

export const SimulationEhrContent = (props: { courseId?: string }) => {
  const [state, setState] = useState({ scenarios: [], isLoading: false });
  const { courseId } = props;

  useEffect(() => {
    if (!courseId) {
      setState({ scenarios: [], isLoading: false });
      return undefined;
    }

    let isCurrent = true;

    const fetchScenariosWithProductMapping = async () => {
      setState((prevState) => ({ ...prevState, isLoading: true }));

      try {
        const { data: scenariosData } = await simulationService.getSimulationScenarioSummaries(courseId);

        if (isCurrent) {
          setState({ scenarios: scenariosData, isLoading: false });
        }
      } catch (err) {
        if (isCurrent) {
          setState({ scenarios: [], isLoading: false });
          apiHelper.showApiError(`can not get simulation scenarios ${err}`);
        }
      }
    };

    fetchScenariosWithProductMapping();

    return () => {
      isCurrent = false;
    };
  }, [courseId]);
  return (
    <div>
      {state.isLoading && <ELSPageLoader />}
      {!state.isLoading && state.scenarios.length && <AssignmentContent content={state.scenarios} {...props} />}
    </div>
  );
};

const mapStateToProps = (state) => ({
  courseId: appSelectors.getCourseId(state)
});

export default connect(mapStateToProps)(SimulationEhrContent);
